import {GetResource} from "../utils/HttpUtil";

export function LoadInfo(infoName) {
    return GetResource(`/infos/${infoName}`);
}
